import script from "./commissions-and-sales-tracking.vue?vue&type=script&setup=true&lang=js"
export * from "./commissions-and-sales-tracking.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__